import { Button, Card } from 'react-bootstrap'
import parse from 'html-react-parser'

import { navigateTo } from 'components/common/navigation'
import { getAllPracticesDetails } from 'components/common/api/Practices'

import { ReactComponent as IconPractices } from '../../../assets/images/icons/icon-practices.svg'
import { useHistory } from 'react-router-dom'
import { buildRequestURL } from 'components/common/api'

/**
 * User Program Practice component: used to display a Practice within the user's program
 */
export default function UserProgramPractice({
  type,
  practiceIndex = 0,
  previewOnly = false,
  className = ''
}) {
  const history = useHistory()
  const practiceDetails = getAllPracticesDetails()

  // Find the practice
  const practice = practiceDetails.find(
    practiceDetail => practiceDetail.preferenceKey === type
  )

  // Return early if we don't have a practice
  if (!practice) return null

  /**
   * Event handler for when the user clicks the "Begin activity" button on the Practice
   */
  const handlePracticeClick = () => {
    const path = practice.path
    const url = buildRequestURL(path, {
      returnPath: history.location.pathname
    })
    navigateTo(url, history)
  }

  return (
    <Card key={practiceIndex} className={`user-program-practice ${className}`}>
      <Card.Body>
        <Card.Title className='mb-4'>
          <span className='icon'>
            <IconPractices />
          </span>
          {practice.title}
        </Card.Title>
        <Card.Text as='div'>
          <p>{parse(practice.description)}</p>
          {!previewOnly && (
            <div className='user-program-practice-actions'>
              <Button
                variant='light'
                size='large'
                className='w-100 text-start'
                onClick={_ => handlePracticeClick()}
              >
                <i className='bi bi-fast-forward'></i>
                Begin {practice.title.toLowerCase()}
              </Button>
            </div>
          )}
        </Card.Text>
      </Card.Body>
    </Card>
  )
}
